import React from "react";
import styles from "./Summary.module.scss";
import {useTranslation} from "react-i18next";
import {useCheckoutContext} from "../../CheckoutContextProvider/CheckoutContextProvider";
import {useCustomerSelector} from "../../../../store";

const SummaryNewsletter: React.FC = () => {
  const {t} = useTranslation();
  const {customer} = useCustomerSelector();
  const {checkout} = useCheckoutContext();

  if (customer.newsletterFlag || checkout.isGuest) {
    return null;
  }

  const onChecked = (evt: React.ChangeEvent<HTMLInputElement>) =>
    void checkout.put({hasNewsletter: evt.target.checked});

  return (
    <div className={styles.additionalOption}>
      <label className={styles.additionalOptionLabel} htmlFor="NewsletterOption">
        <div>
          <input
            className={styles.additionalOptionInput}
            type="checkbox"
            name="newsletter"
            id="NewsletterOption"
            defaultChecked={checkout.hasNewsletter}
            onChange={onChecked}
          />
        </div>
        <p>{t("newsletter.subscribeAgreement")}</p>
      </label>
    </div>
  );
};

export default SummaryNewsletter;
